import { render } from "./VedioViews.vue?vue&type=template&id=64b1e5e3&scoped=true"
import script from "./VedioViews.vue?vue&type=script&lang=js"
export * from "./VedioViews.vue?vue&type=script&lang=js"

import "./VedioViews.vue?vue&type=style&index=0&id=64b1e5e3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64b1e5e3"]])

export default __exports__